import {FETCH_COUNTRY_ISO_CODE_SUCCESS} from "../actions/CountryActions";

const initialState = {
    code: undefined
};

export default function CountryReducer(state = initialState, action) {
    if (action.type === FETCH_COUNTRY_ISO_CODE_SUCCESS) {
        return {
            code: action.payload.code,
        }
    }

    return state;
}